import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "./layouts/Layout";
import Dashboard from "./pages/Dashboard/Dashboard";

import VehicleIndex from "./pages/Vehicle/Index";
import VehicleAdd from "./pages/Vehicle/Add";

import StateIndex from "./pages/State/Index";
import StateAdd from "./pages/State/Add";

import GenerateSlipForm from "./pages/Booking/GenerateSlip";
import GenerateSlip from "./pages/Booking/GenerateSlipList";
import ScheduleBooking from "./pages/Booking/ScheduleBooking";
import AddScheduleBooking from "./pages/Booking/AddScheduleBooking";
import CurrentBooking from "./pages/Booking/CurrentBooking";
import CancelBooking from "./pages/Booking/CancelBooking";
import PendingBooking from "./pages/Booking/PendingBooking";
import CompleteBooking from "./pages/Booking/CompleteBooking";
import AssignVehicleBooking from "./pages/Booking/AssignBooking";
import TrackDetails from "./pages/Booking/TrackDetailsBooking";
import DownloadSlip from "./pages/Booking/DownloadSlip";
import OpeningValve from "./pages/Booking/OpeningValve"

import CityIndex from "./pages/City/Index";
import CityAdd from "./pages/City/Add";

import UserIndex from "./pages/User/Index";
import UserAdd from "./pages/User/Add";
import InactiveUserIndex from "./pages/InactiveUser/Index"

import RoleIndex from "./pages/Role/Index"
import RoleAdd from "./pages/Role/Add"

import UserTypePermissionIndex from "./pages/ManageUsers/UserTypePermission/Index";
import UserPermissionIndex from "./pages/ManageUsers/UserPermission/Index";

import VendorIndex from "./pages/Vendor/Index";
import VendorAdd from "./pages/Vendor/Add";

import DestinationIndex from "./pages/Destination/Index";
import DestinationAdd from "./pages/Destination/Add";

import DriverIndex from "./pages/Driver/Index";
import DriverAdd from "./pages/Driver/Add";

import UsertypeIndex from "./pages/Usertype/Index";
import UsertypeAdd from "./pages/Usertype/Add";

import HydrantIndex from "./pages/Hydrant/Index";
import HydrantAdd from "./pages/Hydrant/Add";

import FareIndex from "./pages/Fare/Index";
import FareAdd from "./pages/Fare/Add";

import GeneralSettingAdd from "./pages/General Setting/Add";
import GeneralSettingAddSubmit from "./pages/General Setting/Add";

import TripReport from "./pages/VerifiedReport/tripReport";
import RevenueReport from "./pages/VerifiedReport/revenueReport";
import MonthlyRevenueReport from "./pages/VerifiedReport/monthlyRevenueReport";

import ProvisionalTripReport from "./pages/ProvisionalReport/provisionalTripReport";
import ProvisionalRevenueReport from "./pages/ProvisionalReport/provisionalRevenueReport";
import ProvisionalMonthlyRevenueReport from "./pages/ProvisionalReport/provisionalMonthlyRevenueReport";

import MapLiveTracking from "./pages/Map/LiveTrack";
import MapHistoryTracking from "./pages/Map/HistoryTrack";
import VolveConfiguration from "./pages/VolveConfiguration/index";
import VolveConfigurationAdd from "./pages/VolveConfiguration/Add"; 

import Login from "./pages/auth/Login";
import Logout from "./pages/auth/Logout";
import { ToastContainer } from "react-toastify";
import HydrantLiveStatusReport from "./pages/HydrantLiveStatus/HydrantLiveStatusReport";
import CircleReport from "./pages/VerifiedReport/CircleReport";
import GeneratedInvoice from "./pages/VerifiedReport/GeneratedInvoice";
import CircleVehicleReport from "./pages/VerifiedReport/CircleVehicleReport";
import WaterReport from "./pages/otherReport/waterReport";
import OtpBooking from "./pages/Booking/OtpBooking";
import CameraIndex from "./pages/Camera/Index";
import CameraAdd from "./pages/Camera/Add";
import CameraNvrIndex from "./pages/CameraNvr/index";
import CameraNvrAdd from "./pages/CameraNvr/Add";
import PlayVideo from "./pages/Camera/PlayVideo";

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route element={<Layout />}>
          <Route path="/" element={<Dashboard />} />

          <Route path="/active-user" element={<UserIndex />} />
          <Route path="/inactive-user" element={<InactiveUserIndex />} />

          <Route path="/Add-User" element={<UserAdd />} />
          <Route path="/Update-User/:id" element={<UserAdd />} />
          <Route path="/role" element={<RoleIndex/>}/>
          <Route path="Add-Role" element={<RoleAdd/>}/>
          <Route path="/Update-role/:id" element={<RoleAdd/>}/>


          <Route path="/role-permission" element={<UserTypePermissionIndex />} />
          <Route path="/User-Permission" element={<UserPermissionIndex />} />


          <Route path="/Vehicle" element={<VehicleIndex />} />
          <Route path="/Add-Vehicle" element={<VehicleAdd />} />
          <Route path="/Update-Vehicle/:id" element={<VehicleAdd />} />


          <Route path="/State" element={<StateIndex />} />
          <Route path="/Add-State" element={<StateAdd />} />
          <Route path="/Update-State/:id" element={<StateAdd />} />


          <Route path="/City" element={<CityIndex />} />
          <Route path="/Add-City" element={<CityAdd />} />
          <Route path="/Update-City/:id" element={<CityAdd />} />


          <Route path="/Vendor" element={<VendorIndex />} />
          <Route path="/Add-Vendor" element={<VendorAdd />} />
          <Route path="/Update-Vendor/:id" element={<VendorAdd />} />


          <Route path="/Destination" element={<DestinationIndex />} />
          <Route path="/Add-Destination" element={<DestinationAdd />} />
          <Route path="/Update-Destination/:id" element={<DestinationAdd />} />


          <Route path="/Driver" element={<DriverIndex />} />
          <Route path="/Add-Driver" element={<DriverAdd />} />
          <Route path="/Update-Driver/:id" element={<DriverAdd />} />


          <Route path="/Usertype" element={<UsertypeIndex />} />
          <Route path="/Add-Usertype" element={<UsertypeAdd />} />
          <Route path="/Update-Usertype/:id" element={<UsertypeAdd />} />


          <Route path="/Hydrant" element={<HydrantIndex />} />
          <Route path="/Add-Hydrant" element={<HydrantAdd />} />
          <Route path="/Update-Hydrant/:id" element={<HydrantAdd />} />


          <Route path="/Fare-Master" element={<FareIndex />} />
          <Route path="/Add-Fare-Master" element={<FareAdd />} />
          <Route path="/Update-Fare-Master/:id" element={<FareAdd />} />

          <Route path="/Volve-Configuration" element={<VolveConfiguration />} />
          <Route path="/Add-Volve-Configuration" element={<VolveConfigurationAdd />} />
          <Route path="/Update-Volve-Configuration/:id" element={<VolveConfigurationAdd />} />

          <Route path="/Camera" element={<CameraIndex />} />
          <Route path="/Add-Camera" element={<CameraAdd />} />
          <Route path="/Update-Camera/:id" element={<CameraAdd />} />
          <Route path="/Play-Video/:id" element={<PlayVideo />} />


<Route path="/camera-nvr" element={<CameraNvrIndex />} />
          <Route path="/Add-camera-nvr" element={<CameraNvrAdd />} />
          <Route path="/Update-camera-nvr/:id" element={<CameraNvrAdd />} />

          <Route path="/General-Settings" element={<GeneralSettingAdd />} />
          <Route path="/General-Settings" element={<GeneralSettingAddSubmit />} />


          <Route path="/Generate-Slip" element={<GenerateSlip />} />
          <Route path="/Generate-Slip/:id" element={<GenerateSlipForm />} />
          <Route path="/Schedule-Booking" element={<ScheduleBooking />} />
          <Route path="/Add-Schedule-Booking" element={<AddScheduleBooking />} />
          <Route path="/Update-Schedule-Booking/:id" element={<AddScheduleBooking />} />


          <Route path="/Cancel-Booking" element={<CancelBooking />} />
          <Route path="/verification-pending" element={<PendingBooking />} />
          <Route path="/otp" element={<OtpBooking />} />
          <Route path="/opening-valve" element={<OpeningValve/>} />
          <Route path="/partial-completion" element={<CompleteBooking />} />
          <Route path="/Assign-Vehicle-Booking/:id" element={<AssignVehicleBooking />} />
          <Route path="/Track-Details-Booking/:id" element={<TrackDetails />} />


          <Route path="/Current-Booking" element={<CurrentBooking status={""} title={"Current Booking"} />} />
          <Route path="/Waiting-For-Driver-Booking" element={<CurrentBooking status={"WAITING FOR DRIVER"} title={"Waiting For Driver Booking"} />} />
          <Route path="/Driver-Assigned-Booking" element={<CurrentBooking status={"DRIVER ASSIGNED"} title={"Driver Assigned Booking"} />} />
          <Route path="/Accept-Booking" element={<CurrentBooking status={"ACCEPT"} title={"Accept Booking"} />} />
          <Route path="/Request-For-Open-Valve-Booking" element={<CurrentBooking status={"REQUEST FOR OPEN VALVE"} title={"Request For Open Valve Booking"} />} />
          <Route path="/On-Going-Booking" element={<CurrentBooking status={"ON GOING"} title={"On Going Booking"} />} />
          <Route path="/Water-Supply-End-Booking" element={<CurrentBooking status={"Water Supply End"} title={"Water Supply End Booking"} />} />
          {/* <Route path="/verification-pending" element={<CurrentBooking status={"Verification Pending"} title={"Verifcation Pending Booking"} />} /> */}
          {/* <Route path="/partial-completion" element={<CurrentBooking status={"P COMPLETE"} title={"Partial Complete Booking"} />} /> */}


          <Route path="/verified-trip-report" element={<TripReport />} />
          <Route path="/verified-revenue-report" element={<RevenueReport />} />
          <Route path="/verified-monthly-revenue-report" element={<MonthlyRevenueReport />} />
          <Route path="/other-circle-report" element={<CircleReport />} />
          <Route path="/other-circle-wise-vehicle-report" element={<CircleVehicleReport />} />
          <Route path="/other-water-report" element={<WaterReport />} />


          <Route path="/Provisional-Trip-Report" element={<ProvisionalTripReport />} />
          <Route path="/Provisional-Revenue-Report" element={<ProvisionalRevenueReport />} />
          <Route path="/Provisional-Monthly-Revenue-Report" element={<ProvisionalMonthlyRevenueReport />} />


          <Route path="/Live-Tracking" element={<MapLiveTracking />} />
          <Route path="/History-Tracking" element={<MapHistoryTracking />} />
          <Route path="/Hydrant-Live-Status" element={<HydrantLiveStatusReport />} />
        </Route>
        <Route path="/Download-Slip/:id" element={<DownloadSlip />} />
        <Route path="/Generated-Invoice" element={<GeneratedInvoice />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
